import SectionHeader from '../components/SectionHeader';

function Contact() {
  return (
    <section className="content-section page-section">
      <SectionHeader label="Get In Touch" title="Contact our consulting team" />
      <div className="contact-grid">
        <div className="contact-card">
          <h3>Send a message</h3>
          <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
            <label>
              Name
              <input type="text" placeholder="Your name" />
            </label>
            <label>
              Email
              <input type="email" placeholder="Your email" />
            </label>
            <label>
              Subject
              <input type="text" placeholder="Subject" />
            </label>
            <label>
              Message
              <textarea placeholder="Your message" rows="5" />
            </label>
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
        <div className="contact-card contact-info-card">
          <h3>Office Information</h3>
          <p>123 Street, New York, USA</p>
          <p>+012 345 67890</p>
          <p>info@example.com</p>
          <p>Mon - Fri: 8:00 - 9:00</p>
        </div>
      </div>
    </section>
  );
}

export default Contact;
